module.exports = __webpack_public_path__ + "static/media/ALPACA.acfa5713.png";